<template>
  <div>
    <v-app>
      <v-content>
        <v-container fluid class="top-hero__content">
          <v-row>
            <v-col class="top-hero__content-text">
              <div class="catch_copy">
                <p>世界で戦える中小企業/人材を<br />「共に」創出する</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <div class="index">
          <h2>ビジョンへかける想い</h2>
          <p class="explanation">
            日本のIT企業は、いま現在、世界で戦うことが十分には出来ていない現状にあります。<br />日本人は海外に目を向けず、日本の中で閉じこもる傾向が強くあります。<br />その中で、我々は、我々が生み出す企業や事業、人材は世界で戦えるレベルの独自性を持っている必要があると考えています。<br />そして、そのような企業や事業、人材を我々が生み出すのではなく、貴社と「共に」に生み出していく。その過程と結果に価値があると考えています。
          </p>
        </div>
        <div class="index">
          <h2>ミッション</h2>
          <p class="explanation">
            凄まじい勢いで進むIT化。<br />その中で、ITを使える人と、そうでない人の格差は広がるばかりです。<br />これらの格差を撲滅し、IT弱者と呼ばれる人々をなくす。<br />それが我々のミッションです。<br />格差を撲滅するための戦いの過程で、ITを使ってクライアントがもつ古い業界常識破壊し、新たな価値を想像していきます。<br />このようなことを実現する人材として、エンジニア業務に依存せず柔軟にあらゆることに対応できる、<br />課題解決ができる人材を育成していきます。
          </p>
        </div>
        <div class="index">
          <h2>バリュー</h2>
          <p class="explanation">
            既存の業界常識を超えた事業活動の展開を実現するため、<br />社内の業務フロー効率化及び他業界のビジネスモデル転用など、お客様の社内リソースの最大化できるよう努めます。<br />世界に挑める価値を提供するために、スキルに依存しない柔軟な仕事を行い、<br />その過程ではお客様と常に対等にディスカッションし、勇気ある行動ができる関係を築きます。
          </p>
        </div>

        <div class="index">
          <h2>会社情報</h2>
          <table class="table table-bordered kaisha">
            <tbody>
              <tr>
                <th>会社名</th>
                <td>
                  株式会社ゲリラスペース（英文表記：Guerilla Space, Inc.）
                </td>
              </tr>
              <tr>
                <th>設立日</th>
                <td>2020年10月28日</td>
              </tr>
              <tr>
                <th>所在地</th>
                <td>会社清算のため現在拠点なし</td>
              </tr>
              <tr>
                <th>事業内容</th>
                <td>
                  <ul>
                    <li>スペース型IT教育事業</li>
                    <li>WEBシステム開発</li>
                    <li>新規WEBサービスの立ち上げ支援</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>資本金</th>
                <td>100万円</td>
              </tr>
              <tr>
                <th>代表者</th>
                <td>生駒勇太</td>
              </tr>
              <tr>
                <th>取引銀行</th>
                <td>きらぼし銀行 代々木支店</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import SmileImage from "@/assets/img/smile-logo.png";

export default {
  data: function () {
    return {
      smilelogo: SmileImage,
    };
  },
};
</script>

<style lang="scss" scoped>
.top-hero__content {
  background-image: url("../assets/img/gs_logo.png");
  background-color: rgba(255, 255, 255, 0.8);
  background-blend-mode: lighten;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;

  &-text {
    color: black;
    text-align: center;
    font-weight: bold;
    font-family: "メイリオ", "Meiryo", sans-serif;
    font-size: 5vw;
    height: 20vh;
  }

  .catch_copy {
    padding-top: 1rem;
  }

  @include display_pc {
    height: 55vh;
    font-size: 5vw;
  }
}

.box_info {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10rem;
}
.box_srcollbar {
  overflow: auto;
  width: 100%;
  height: 40px;
  padding: 5px;
  border: 1px solid #000;
  background-color: #f9f9f9;
  color: #000;
  font-size: 20px;
  text-align: center;
}
.box_title {
  border: 1px solid #000;
  text-align: center;
  padding: 5px;
  width: 100%;
  font-weight: bold;
  font-size: 20px;
  background-color: #dcdcdc;
  color: #000;
}
h2 {
  position: relative;
  padding: 0.25em 0;
}
h2:after {
  content: "";
  display: block;
  height: 4px;
  background: -webkit-linear-gradient(to right, rgb(66, 64, 64), transparent);
  background: linear-gradient(to right, rgb(66, 64, 64), transparent);
}

.index {
  margin: 20px;
  padding: 20px;
}
.explanation {
  font-weight: bold;
  letter-spacing: 0.12em;
  font-size: 1rem;
}

.explanation .emphasis {
  font-size: 1.5rem;
  font-family: Times New Roman, "メイリオ";
}
.case-study {
  position: relative;
  margin: 2em 0;
  padding: 0.5em 1em;
  border: solid 3px #7d7f81;
  border-radius: 8px;
}

.case-study .case-study-title {
  position: absolute;
  display: inline-block;
  top: -13px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 19px;
  background: #fff;
  color: #7d7f81;
  font-weight: bold;
}
.case-study p {
  margin: 0;
  padding: 0;
}

.case-study ul,
ol {
  background: #fcfcfc; /*背景色*/
  padding: 0.5em 0.5em 0.5em 2em; /*ボックス内の余白*/
  border: solid 3px gray; /*線の種類 太さ 色*/
}

.case-study ul li,
ol li {
  line-height: 1.5; /*文の行高*/
  padding: 0.5em 0; /*前後の文との余白*/
}

.kaisha {
  width: 100%;
  margin: 20px;
  padding: 20px;
}

.kaisha th,
.kaisha td {
  border: 1px solid #ccc;
  padding: 20px;
}

.kaisha th {
  font-weight: bold;
  background-color: #dedede;
}

@media screen and (max-width: 767px) {
  .kaisha,
  .kaisha tr,
  .kaisha td,
  .kaisha th {
    display: block;
  }
  .kaisha th {
    width: auto;
  }
}
</style>
